export const removeSpecialCharacters = (str: string) => {
  // remove all other special characters besides spaces and dashes
  return str.replace(/[^a-zA-Z0-9 -]/g, '')
}
